import { s as status, b as set, d as delay, f as fetch, e as json } from './fetch-deps.js';
import { c as cookie, b as body, t as text, x as xml } from './xml-deps.js';
import { d as data, e as errors } from './errors-deps.js';

var index = /*#__PURE__*/Object.freeze({
	__proto__: null,
	status: status,
	set: set,
	cookie: cookie,
	body: body,
	data: data,
	delay: delay,
	errors: errors,
	fetch: fetch,
	json: json,
	text: text,
	xml: xml
});

export { index as i };
